import {Line, mixins} from 'vue-chartjs'
import Vue from 'vue'

const {reactiveProp} = mixins;
let options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        xAxes: [{
            type: "time",
            time: {format: "YYYY-MM-DD", tooltipFormat: 'll'},
            scaleLabel: {display: true, labelString: 'Date'}
        }],
        yAxes: [{
            type: "linear",
            scaleLabel: {display: true, labelString: 'Ethereum (Ξ)'}
        }],
    }
};
export default {
    deactivateAnimation() {
        Vue.nextTick(() => {
            options['animation'] = false;
        })
    },
    extends: Line,
    mixins: [reactiveProp],
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.options = options;
        this.renderChart(this.chartData, this.options);
    }
}
